angular.module('account').factory('ConsentService',
    ['$sce', '$q', 'ConsentRepository', 'LocalStorageRepository', 'configuration',
        function ($sce, $q, ConsentRepository, LocalStorageRepository, configuration) {
            'use strict';

            var currentPatientConsent = {
                PatientId: null,
                Version: 0,
                IsAccepted: false,
                AlwaysDisplayConsent: false,
                ConsentForm: null,
            };

            function replaceLineBreaksWithHtmlLineBreak(text) {
                var returnText = text;

                var re = new RegExp('\r\n', 'g');
                returnText = returnText.replace(re, '<br/>');

                re = new RegExp('\n', 'g');
                returnText = returnText.replace(re, '<br/>');

                return returnText;
            }

            function getPrivacyPolicyUrl() {
                return ConsentRepository
                    .getAgreementPrivacyPolicyPath(LocalStorageRepository.getUserID())
                    .then(function (data) {
                        var baseurl = LocalStorageRepository.getClientURL() + '/api/patient/' + configuration.SERVER_API_VERSION + '/',
                            path = 'consents/' + data.Path,
                            apiKey = configuration.API_KEY,
                            pdfUrl = baseurl + path + '?apikey=' + apiKey;

                        var privacyPolicyUrl = $sce.trustAsResourceUrl(pdfUrl);
                        return privacyPolicyUrl;
                    });
            }

            function getPracticeConsent() {
                return ConsentRepository
                    .getPracticeConsent(LocalStorageRepository.getUserID())
                    .then(function (data) {
                        var currentPracticeConsent = {
                            IsAccepted: data.IsAccepted,
                            ConsentForm: $sce.trustAsHtml(replaceLineBreaksWithHtmlLineBreak(data.ConsentForm))
                        };
                        return currentPracticeConsent;
                    });
            }

            function getChartConsent(patientId) {
                if (currentPatientConsent.PatientId !== patientId) {
                    clearChartConsent();
                }

                if (!currentPatientConsent.PatientId) {
                    return ConsentRepository
                        .getChartConsent(patientId)
                        .then(function (data) {
                            currentPatientConsent = {
                                PatientId: patientId,
                                Version: data.Version,
                                IsAccepted: data.IsAccepted,
                                AlwaysDisplayConsent: data.AlwaysDisplayConsent,
                                ConsentForm: data.ConsentForm,
                            };

                            var consentHtml = $sce.trustAsHtml(replaceLineBreaksWithHtmlLineBreak(currentPatientConsent.ConsentForm));
                            currentPatientConsent.ConsentForm = consentHtml;
                            return currentPatientConsent;
                        });
                } else {
                    return $q.when(currentPatientConsent);
                }
            }

            function postChartConsent(patientId) {
                if (currentPatientConsent.PatientId === patientId) {
                    currentPatientConsent.IsAccepted = true;
                    LocalStorageRepository.setOncePerLoginChartConsent(true);
                } else {
                    clearChartConsent();
                }

                return ConsentRepository
                    .postChartConsent(patientId)
                    .then(function () {
                        return;
                    });
            }

            function clearChartConsent() {
                currentPatientConsent = {
                    PatientId: null,
                    Version: 0,
                    IsAccepted: false,
                    AlwaysDisplayConsent: false,
                    ConsentForm: null,
                };
            }

            function isChartConsentAccepted(patientId) {
                return getChartConsent(patientId)
                    .then(function (data) {
                        var myPatientConsent = data;
                        return !!(myPatientConsent && myPatientConsent.PatientId && myPatientConsent.PatientId === patientId && ( LocalStorageRepository.getOncePerLoginChartConsent() || (myPatientConsent.IsAccepted && !myPatientConsent.AlwaysDisplayConsent)));
                    });
            }

            return{
                getPrivacyPolicyUrl: getPrivacyPolicyUrl,
                getPracticeConsent: getPracticeConsent,
                getChartConsent: getChartConsent,
                postChartConsent: postChartConsent,
                isChartConsentAccepted: isChartConsentAccepted,
                clearChartConsent: clearChartConsent
            };
        }
    ]
);